module.exports = __webpack_public_path__ + "img/extruder.9abb1308.jpg";